import { FleetDefinition } from './../models/FleetDefinition';

export class GetFleetDefinitionsResponse {
    fleetDefinitions?: FleetDefinition[];
}